import {IPriceTypeFilterModel, priceTypesModel, venueLevelModel, IVenueLevelModel,
    priceRangeModel, IPriceRangeModel, additionalSeatingOptionModel, IAdditionalSeatingOptionModel, IErrorModel, errorModel } from '../filter/reducers/filter-reducers';
import {appSettingsModel} from './fetch-settings-reducer';
import {promoCodeModel, IPromoCodeModel} from '../filter/reducers/promo-reducer';
import {ISeatMatchResultModel, seatMatchResultModel} from '../filter/reducers/fetch-reducer';
import {ISeatMapModel, seatMapModel} from '../seatmap/reducers/seatmap-reducer';
import {ISeatMapResultModel, seatMapResultModel} from '../seatmap/reducers/fetch-reducer';
import {cartModel, ICartModel} from '../cart/reducers/cart-reducer';

import {applicationModel, IApplicationModel} from './app-reducer';
import {IAppSettingsModel} from '../reducers/fetch-settings-reducer';
import * as redux from 'redux';
import { IExchangeSettingsModel, exchangeSettingsModel } from './exchange-reducer';

export interface IAppState {    
    applicationModel: IApplicationModel;
    errorModel: IErrorModel;
    seatMatchResultModel: ISeatMatchResultModel;
    priceTypesModel: IPriceTypeFilterModel;
    appSettingsModel: IAppSettingsModel;
    venueLevelModel: IVenueLevelModel;
    promoCodeModel: IPromoCodeModel;
    priceRangeModel: IPriceRangeModel;
    exchangeSettingsModel: IExchangeSettingsModel;
    additionalSeatingOptionModel: IAdditionalSeatingOptionModel;
    seatMapResultModel: ISeatMapResultModel;
    seatMapModel: ISeatMapModel;
    cartModel: ICartModel;
    dispatch?: any /*redux.Dispatch<any> redux.Dispatch can't interpret react-redux dispatch method and react-redux typings exports Redux.Dispatch.*/;
    location?: any;
    children?: any;
}

export const appReducers = redux.combineReducers({    
    errorModel,
    priceTypesModel,
    seatMatchResultModel,
    appSettingsModel,
    promoCodeModel,
    priceRangeModel,
    venueLevelModel,
    additionalSeatingOptionModel,
    seatMapResultModel,
    seatMapModel,
    cartModel,
    applicationModel,
    exchangeSettingsModel
});